import { APIServiceConfigInterface } from "@swivl-mono/types";

import { AIAPI } from "./APIs/AI.API";
import { AccountAPI } from "./APIs/Account.API";
import { AnalyticsAPI } from "./APIs/Analytics.API";
import { AppsAPI } from "./APIs/Apps.API";
import { AuthAPI } from "./APIs/Auth.API";
import { BrainsAPI } from "./APIs/Brains.API";
import { BrandsAPI } from "./APIs/Brands.API";
import { BullAPI } from "./APIs/Bull.API";
import { CampaignAPI } from "./APIs/Campaign.API";
import { ConversationsAPI } from "./APIs/Conversations.API";
import { DebugAPI } from "./APIs/Debug.API";
import { EmbedsAPI } from "./APIs/Embeds.API";
import { EscalationsAPI } from "./APIs/Escalations.API";
import { EventsAPI } from "./APIs/Events.API";
import { FMSAPI, FMSServiceProviderInterface } from "./APIs/FMS.API";
import { GoogleAPI } from "./APIs/Google.API";
import { GroupAPI } from "./APIs/Group";
import { JourneysAPI } from "./APIs/Journeys.API";
import { LeadsAPI } from "./APIs/Leads.API";
import { LeasesAPI } from "./APIs/Leases.API";
import { LegacyServerAPI } from "./APIs/LegacyServer.API";
import { LocationVarsAPI } from "./APIs/LocationVars.API";
import { LocationsAPI } from "./APIs/Locations.API";
import { MemberInviteAPI } from "./APIs/MemberInvite.API";
import { MembersAPI } from "./APIs/Members.API";
import { MessagesAPI } from "./APIs/Messages.API";
import { MessagingAPI } from "./APIs/Messaging.API";
import { NLPAPI } from "./APIs/NLP.API";
import { NotesAPI } from "./APIs/Notes.API";
import { NotificationsAPI } from "./APIs/Notifications.API";
import { OrgsAPI } from "./APIs/Orgs.API";
import { PaymentsAPI } from "./APIs/Payments.API";
import { QuestsAPI } from "./APIs/Quests.API";
import { ReviewsAPI } from "./APIs/Reviews.API";
import { RolesAPI } from "./APIs/Roles.API";
import { S3API } from "./APIs/S3.API";
import { SMSGroupsAPI } from "./APIs/SMSGroups.API";
import { SequencesAPI } from "./APIs/Sequences.API";
import { SessionsAPI } from "./APIs/Sessions.API";
import { SpotAPI } from "./APIs/Spot.API";
import { SyncAPI } from "./APIs/Sync.API";
import { TablesAPI } from "./APIs/Tables.API";
import { TenantsAPI } from "./APIs/Tenants.API";
import { TimeAPI } from "./APIs/Time.API";
import { TopicsVersionsAPI } from "./APIs/TopicVersion.API";
import { URLAPI } from "./APIs/URL.API";
import { UnitsAPI } from "./APIs/Units.API";
import { UserVarsAPI } from "./APIs/UserVars.API";
import { UsersAPI } from "./APIs/Users.API";
import { VarsAPI } from "./APIs/Vars.API";
import { VoiceAPI } from "./APIs/Voice.API";
import { APIService } from "./Service/API.Service";

export class API {
  static init(config: {
    Server?: APIServiceConfigInterface;
    LegacyServer?: APIServiceConfigInterface; //temporary until we migrate over, used for bull
    FMS?: APIServiceConfigInterface;
    Sync?: APIServiceConfigInterface;
    Messaging?: APIServiceConfigInterface;
    Channels?: APIServiceConfigInterface;
    Notifications?: APIServiceConfigInterface;
    Bull?: APIServiceConfigInterface;
    Analytics?: APIServiceConfigInterface;
    FMSServiceProvider?: FMSServiceProviderInterface;
  }) {
    APIService.init(config);
  }
  static log() {
    APIService.log();
  }

  static Account = AccountAPI;
  static AI = AIAPI;
  static Apps = AppsAPI;
  static Auth = AuthAPI;
  static Analytics = AnalyticsAPI;
  static Brains = BrainsAPI;
  static Brands = BrandsAPI;
  static Bull = BullAPI;

  // static Cache: CacheAPIInterface = new CacheAPI();
  static Campaign = CampaignAPI;
  static Conversations = ConversationsAPI;
  static Debug = DebugAPI;
  static Embeds = EmbedsAPI;
  static Escalations = EscalationsAPI;
  static Events = EventsAPI;
  static FMS = FMSAPI;
  static Google = GoogleAPI;
  static Group = GroupAPI;
  static Journeys = JourneysAPI;
  static Leases = LeasesAPI;
  static Leads = LeadsAPI;
  static LegacyServer = LegacyServerAPI;
  static Locations = LocationsAPI;
  static LocationVars = LocationVarsAPI;
  static MemberInvite = MemberInviteAPI;
  static Members = MembersAPI;
  static Messages = MessagesAPI;
  static Messaging = MessagingAPI;
  static NLP = NLPAPI;
  static Notes = NotesAPI;
  static Notifications = NotificationsAPI;

  static Org = OrgsAPI;
  static Payments = PaymentsAPI;
  static Quests = QuestsAPI;
  static Reviews = ReviewsAPI;
  static Roles = RolesAPI;
  static S3 = S3API;
  static Sessions = SessionsAPI;
  static Sequences = SequencesAPI;
  static SMSGroups = SMSGroupsAPI;
  static Spot = SpotAPI;
  static Sync = SyncAPI;
  static Tables = TablesAPI;
  static Tenants = TenantsAPI;
  static Time = TimeAPI;
  static TopicsVersions = TopicsVersionsAPI;
  static Units = UnitsAPI;
  static Users = UsersAPI;
  static UserVars = UserVarsAPI;
  static Vars = VarsAPI;
  static Voice = VoiceAPI;
  static URL = URLAPI;
}
